import { FC } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import { useDP3Store } from '@elem/compPage/DP3/DP3Provider';
import EfImg from 'elem/ui/ef-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper';

const TheComp: FC = () => {
    const { t } = useLang('dp3');
    const { pageStatus } = useDP3Store();
    const [isPC, setIsPC] = useState(true);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsPC(window.innerWidth > 1024);
        }
    }, []);

    return (
        <div className={`${css.thecomp}`}>
            <p className="title">Quiet Comfort for Your Home and Neighbours, Too!</p>
            {isPC ? (
                <div className="box">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726666868653/7.jpg" />
                    <div className="info">
                        <div className="l">Silent as a Whisper</div>
                        <div className="r">
                            <p className="desc">
                                It's whisper-quiet with X-Quiet technology, ensuring a peaceful hum*, promising you a night of peaceful sleep even if you keep
                                it beside your bed. It's so silent that you'll hardly notice it's there.
                            </p>
                            <p className="tip">*as low as 30 dB thanks to our X-Quiet tech</p>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="box">
                    <Swiper
                        className="swiper-box"
                        loop={false}
                        // autoplay={{
                        //     delay: 4250,
                        //     disableOnInteraction: false,
                        // }}
                    >
                        <SwiperSlide className={`swiper-item`}>
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726716764034/1-4-tuya.jpg" />
                        </SwiperSlide>
                    </Swiper>
                    <div className="info">
                        <p className="l">Silent as a Whisper</p>
                        <div className="r">
                            <p className="desc">
                                It's whisper-quiet with X-Quiet technology, ensuring a peaceful hum*, promising you a night of peaceful sleep even if you keep
                                it beside your bed. It's so silent that you'll hardly notice it's there.
                            </p>
                            <p className="tip">*as low as 30 dB thanks to our X-Quiet tech</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TheComp;
